import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import { formSettings } from './../settings';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { getDisclosureContent } from './assets/disclosure';
import { sign } from '../../../../../../reducers/signatures';
import { setProgressionProperties, getAdmin } from '../../../../../../reducers/onboarding';
import Signature from '../../../../../../components/signature';
import { getUserBackgroundChecks, saveUserBackgroundCheck, updateBackgroundCheck } from '../../../../../../reducers/backgroundCheck';
import { Signatures } from '../../../../../../utilities/signatureTypes';
import mixpanel from 'mixpanel-browser';
class BackgroundCheckDRBStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'employee', step: 'BackgroundCheckDRBStep' } });

        const { admin, client, getAdmin, job, userId, backgroundCheck, getUserBackgroundChecks, saveUserBackgroundCheck } = this.props;
        const { disclosure_regarding_bg_info_signed } = backgroundCheck;

        if (!admin) {
            getAdmin(client.admin_id);
        }

        const createBackgroundCheckIfMissing = response =>
            response.length === 0 && saveUserBackgroundCheck(userId, job.id, { disclosure_regarding_bg_info_signed });

        if (!backgroundCheck.id) {
            getUserBackgroundChecks(userId, createBackgroundCheckIfMissing);
        }
    }

    submit(values, action) {
        const { role, job, sign, setProgressionProperties, backgroundCheck, updateBackgroundCheck } = this.props;
        const { disclosure_regarding_bg_info_signed } = backgroundCheck;

        sign(role, `${Signatures.types.BG_CHECK_DRB.name}:${job.id}`, ({ id }) => {
            setProgressionProperties({ agreementBGdrb: true });

            if (!disclosure_regarding_bg_info_signed) {
                updateBackgroundCheck(backgroundCheck.id, { disclosure_regarding_bg_info_signed: id }, action);
                return;
            }

            action();
        });
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, admin, job } = this.props;
        if (!admin) {
            return null;
        }

        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row">
                    <div className="col-xs-12">
                        <FormattedMessage id={'onboard2.backgroundCheckDRB.intro'} defaultMessage={'Disclosure'} tagName={'h5'} />
                    </div>
                </div>
                <div className="row section">
                    <div className="col-xs-12">
                        <div className="scrolled">{getDisclosureContent(admin)}</div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <Signature name={`${Signatures.types.BG_CHECK_DRB.name}:${job.id}`} />
                    </div>
                </div>

                <WizardButtons disabled={submitting} back={{ action: back }} submit={{ message: <FormattedMessage {...messages.signAndContinue} /> }} />
            </form>
        );
    }
}

BackgroundCheckDRBStep = reduxForm(formSettings)(BackgroundCheckDRBStep);

const mapStateToProps = state => {
    const profile = state.identity.profile;
    return {
        role: state.identity.role,
        job: state.onboarding.job,
        admin: state.onboarding.admin,
        client: state.onboarding.client,
        userId: profile ? profile.id : undefined,
        backgroundCheck: state.backgroundCheck.current
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmin: getAdmin,
            sign: sign,
            setProgressionProperties: setProgressionProperties,
            getUserBackgroundChecks,
            saveUserBackgroundCheck,
            updateBackgroundCheck
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundCheckDRBStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/backgroundCheckDRB.jsx